const swiper = {
  props: {
    dynamicClass: ".c-swiper.dynamicLoading",
    cssSelector: "c-swiper",
    containerSelector: "swiper-JS",
    wrapperSelector: "swiper-wrapper",
    allSwipers: [],
    slidesMove: 2,
    animationInterval: 500,
    isMoving: [],
  },
  init: function () {
    bcl.u.loadStyleSheet("/etc.clientlibs/barcelo/clientlibs/clientlib-swiper.css", this.props.dynamicClass);

    if (bcl.editMode) {
      return;
    }

    const elements = document.querySelectorAll("." + this.props.cssSelector);

    elements.forEach((element, index) => {
      element.classList.add("swiperElement_" + index);

      const swiper = new window.Swiper(element, {
        slidesPerView: "auto",
        spaceBetween: 2,
        freeMode: true,
        mode: "horizontal",
        lazy: true,
        lazyPreloadPrevNext: 2,
        speed: 1100,
      });

      this.props.allSwipers.push(swiper);
      this.props.isMoving[index] = false;

      window.allSwipers = this.props.allSwipers;
      window.allSwipers[index].realIndex = 0;

      this.initListeners(index);
    });
  },

  initListeners: function (index) {
    //---------------------------- TRANSITION MOVE -------------------------------//

    // Check if swiper is playing
    window.allSwipers[index].on("transitionEnd", () => {
      this.props.isMoving[index] = false;
    });

    //---------------------------- RIGHT MOVE -------------------------------//

    window.allSwipers[index].hostEl.parentElement.querySelector(".swiper-ui__area-next").addEventListener("mouseover", () => {
      this.props.interval = setInterval(() => {
        if (!this.props.isMoving[index]) {
          this.props.isMoving[index] = true;

          if (document.querySelector("html").dir === "rtl") {
            window.allSwipers[index].changeLanguageDirection("rtl");
          } else {
            window.allSwipers[index].changeLanguageDirection("ltr");
          }

          this.menuScrollLogicRigth(index);
        }
      }, this.props.animationInterval);
    });

    window.allSwipers[index].hostEl.parentElement.querySelector(".swiper-ui__area-next").addEventListener("mouseout", () => {
      window.clearInterval(this.props.interval);
      this.resetSlides();
    });

    //---------------------------- LEFT MOVE -------------------------------//

    window.allSwipers[index].hostEl.parentElement.querySelector(".swiper-ui__area-prev").addEventListener("mouseover", () => {
      this.props.interval = setInterval(() => {
        if (!this.props.isMoving[index]) {
          this.props.isMoving[index] = true;

          if (document.querySelector("html").dir === "rtl") {
            window.allSwipers[index].changeLanguageDirection("rtl");
          } else {
            window.allSwipers[index].changeLanguageDirection("ltr");
          }

          this.menuScrollLogicLeft(index);
        }
      }, this.props.animationInterval);
    });

    window.allSwipers[index].hostEl.parentElement.querySelector(".swiper-ui__area-prev").addEventListener("mouseout", () => {
      window.clearInterval(this.props.interval);
      this.resetSlides();
    });
  },

  resetSlides: function () {
    const elements = document.querySelectorAll("." + this.props.cssSelector);
    elements.forEach((element, index) => {
      this.props.isMoving[index] = false;
    });
  },
  menuScrollLogicRigth: function (index) {
    window.allSwipers[index].slideTo(window.allSwipers[index].activeIndex + this.props.slidesMove);
  },

  menuScrollLogicLeft: function (index) {
    window.allSwipers[index].slideTo(window.allSwipers[index].activeIndex - this.props.slidesMove);
  },
};

export default swiper;
